module.exports = __webpack_public_path__ + "static/media/idrt-logo.99185d69.jpg";